import { Fragment } from 'react';
import { rage } from '~/rage';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { BgPlaceholder } from './components/BgPlaceholder';
import { CameraSettings, EntitySelector } from './views';

const LayoutComponent = () => {
	return (
		<Fragment>
			{rage.config.isStub() && <BgPlaceholder />}
			<EntitySelector />
			<CameraSettings />
		</Fragment>
	);
};

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.GreenScreen)
	.build();

export default Layout;
